
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/template",
      function () {
        return require("private-next-pages/form/template/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/template"])
      });
    }
  